import React from 'react';
import './App.css';
import IrfanHaroonImg from './assets/images/Irfan Haroon.jpeg';

const highlights = [
  'Seasoned litigator admitted in 1986 with appearances across District Courts, the Sindh High Court, and the Supreme Court.',
  'Trilingual (English, Urdu, Sindhi) to support multinational partners, overseas Pakistanis, and local communities alike.',
  'A hands-on practice that merges courtroom advocacy with long-term advisory retainers for boards and leadership teams.',
];

const advisorRoles = [
  { title: 'Principal Legal Advisor', orgs: ['AB Engineering', 'Deokjae Constructions', 'Dynamova Pakistan', 'Jafsons', 'Jama Engineering'] },
  { title: 'Advocate & Legal Consultant', orgs: ['Export Processing Zone Authority Pakistan', "Joe's Fashion (Group of Companies)", 'Oslo Contracts Private Limited'] },
];

function AboutUs() {
  return (
    <main className="about">
      <section className="profile-intro">
        <div>
          <p className="eyebrow">About the practice</p>
          <h2>A law firm balancing tradition with modern commercial insight.</h2>
          {highlights.map((item) => (
            <p key={item}>{item}</p>
          ))}
        </div>
        <div className="profile-card">
          <img src={IrfanHaroonImg} alt="Irfan Haroon" />
          <div>
            <h3>Irfan Haroon</h3>
            <p>Advocate Supreme Court and High Court · Founder</p>
            <p>
              Known for his unwavering preparation, Irfan remains personally involved in every matter that leaves the
              firm&apos;s chambers.
            </p>
          </div>
        </div>
      </section>

      <section className="story">
        <div>
          <p className="eyebrow">Legacy</p>
          <h2>From Karachi courtrooms to nationwide mandates.</h2>
          <p>
            The firm originated in Saddar, Karachi, before expanding to Bukhari Commercial and Sindhi Muslim to stay close to
            both corporate and residential clients. Our mission has stayed the same: translate complex legal realities
            into decisive plans that clients can act on.
          </p>
        </div>
        <div className="timeline">
          <div>
            <strong>1986</strong>
            <span>Admitted to the Sindh Bar Council after apprenticeships with senior counsel.</span>
          </div>
          <div>
            <strong>1994</strong>
            <span>Built a litigation portfolio spanning civil, rent, and succession matters for industrial groups.</span>
          </div>
          <div>
            <strong>Present</strong>
            <span>Combines courtroom advocacy with preventative advisory for boards, investors, and overseas families.</span>
          </div>
        </div>
      </section>

      <section className="advisor-grid">
        <p className="eyebrow">Mandates &amp; advisory</p>
        <h2>Leaders who trust Irfan Haroon &amp; Advocates.</h2>
        <div className="grid">
          {advisorRoles.map(({ title, orgs }) => (
            <article key={title}>
              <h3>{title}</h3>
              <ul>
                {orgs.map((org) => (
                  <li key={org}>{org}</li>
                ))}
              </ul>
            </article>
          ))}
        </div>
      </section>
    </main>
  );
}

export default AboutUs;
